<template>
  <div class="sc-message--system" 
      :class="{
        sent: message.author === 'me',
        received: message.author !== 'me'
      }">
    <!-- :style="messageColors" -->
    {{data.text}}
    <p v-if="data.meta" class='sc-message--meta' >
      <!-- :style="{color: messageColors.color}" -->
      {{data.meta}}</p>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
    // ,
    // messageColors: {
    //   type: Object,
    //   required: true
    // }
  }
}
</script>

<style scoped>
@import "./styles/systemMessage.css";
</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/SystemMessage.vue